<app-dialog-wrapper
    heading="common.put-request-on-hold-dialog.title"
    description="common.put-request-on-hold-dialog.description"
    confirmLabel="common.put-request-on-hold-dialog.confirm"
    cancelLabel="common.general.cancel"
    width="650px"
    [confirmDisabled]="formGroup.invalid"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <form [formGroup]="formGroup" class="w-full">
        <sh-editor
            formControlName="comment"
            [placeholder]="'request.requestDetail.putRequestOnHoldDialog.comment' | translate"
            class="w-full"
        ></sh-editor>
    </form>
</app-dialog-wrapper>
